<template>

    <el-alert
    class="el-alert"
    v-for="w in alerts_actual.value" :key="w"
    :title="w.title"
    :type="w.type"
    :description="w.txt"
    effect="dark"
    :closable="isClosable"
    show-icon
    />

</template>

<script>
import { reactive } from '@vue/reactivity'
import axios from 'axios'

export default {
    props: {isClosable: Boolean},
    setup() {
        const alerts_actual = reactive({value: []})

        axios({
            method: 'get',
            url: 'getalerts.php',
        })
            .then(resp => {
                alerts_actual.value = [];
                for(let alert of resp.data){
                    let parsed = alert.replace(/<[^>]*>?/gm, "").split("\n");
                    if(Date.now() < new Date(parsed[3]) && parsed.length == 4){
                        alerts_actual.value.push(
                            {
                                title: parsed[0],
                                txt: parsed[1],
                                type: parsed[2]
                            }
                        )
                    }
                }
            })

            .catch(() => {
                alerts_actual.value = [];
            })


        return {alerts_actual}
        
    },
}
</script>

<style scoped>

.el-alert {
    margin: auto;
    border-radius: 3px;
    margin-bottom: 10px;
    max-width: 1230px;
}

</style>